import React, { useEffect, useState } from "react";
import "./TopUp.scss";
import { PaymentSummary, PaymentType, PlanSelect } from "../../../containers";
import { useParams } from "react-router-dom";
import { clipText, copyToClipboard } from "../../../utils/services/other";
import { MdOutlineContentCopy } from "react-icons/md";
import History from "../../../utils/services/GlobalNavigation/navigationHistory";
import ReactLoading from "react-loading";

function TopUp() {
  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [currentScreen, setCurrentScreen] = useState<string | null>(null);
  const [transactionData, setTransactionData] = useState<any>(null);
  const { paymentStatus } = useParams();
  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (paymentStatus === "success") {
        setCurrentScreen("SuccessScreen");
        const transaction_id = urlParams.get("transaction-id");
        setTransactionData({ transaction_id });
      }
      if (paymentStatus === "cancel") {
        setCurrentScreen(null);
        History.navigate("/dashboard/topup");
      }
    }

    return () => {
      mounted = false;
    };
  }, [paymentStatus]);

  return (
    <div className="topup" style={{ height: "100%", width: "100%" }}>
      {(() => {
        switch (currentScreen) {
          case "PaymentType":
            return (
              <PaymentType
                setCurrentScreen={setCurrentScreen}
                selectedPlan={selectedPlan}
              />
            );
          case "PaymentCrypto":
            return (
              <PaymentSummary
                setCurrentScreen={setCurrentScreen}
                selectedPlan={selectedPlan}
              />
            );
          case "Loading":
            return (
              <div className="loadingContainer">
                <ReactLoading
                  type={"bubbles"}
                  color={"#4452FE"}
                  height={667}
                  width={375}
                />
              </div>
            );

          case "SuccessScreen":
            return (
              <div className="successScreen">
                <div className="successScreen__card">
                  <p>Transaction Completed </p>
                  <img src="/icons/done.png" alt="transactionDone" />

                  <p>Transaction ID</p>
                  <p>
                    {clipText(transactionData?.transaction_id, 20)} &nbsp;{" "}
                    <span
                      className="icon ptr"
                      onClick={() => {
                        copyToClipboard(transactionData?.transaction_id);
                      }}
                    >
                      <MdOutlineContentCopy />
                    </span>
                  </p>

                  <hr />
                  <p
                    className="ptr"
                    onClick={() => {
                      History.navigate("/dashboard");
                    }}
                  >
                    Go Back
                  </p>
                </div>
              </div>
            );
          default:
            return (
              <PlanSelect
                setSelectedPlan={setSelectedPlan}
                setCurrentScreen={setCurrentScreen}
              />
            );
        }
      })()}
    </div>
  );
}

export default TopUp;
